export default __webpack_public_path__ + "static/media/users.762f5aea.svg";